import React from 'react';

import { FormControl } from 'components/v2/Form/FormControl/FormControl';
import { getFormControlIds } from 'components/v2/Form/FormControl/FormControl.utils';
import { SelectInput } from 'components/v2/Inputs/SelectInput/SelectInput';

import { Props } from './SelectField.types';

export const SelectField = ({
  status = 'default',
  label,
  id,
  required,
  helperText,
  description,
  placeholder,
  searchPlaceholder,
  onChange,
  selected,
  options,
  searchable,
  labelBg,
  wrapSelectedOptionText,
  hideHelperText,
  positionStatic,
  maxMenuHeight,
  multiSelect
}: Props): React.JSX.Element => {
  const ids = getFormControlIds(id);
  const labelId = ids.label;
  const dropdownId = `${ids.input}-dropdown`;

  return (
    <FormControl
      status={status}
      label={label}
      required={required}
      helperText={helperText}
      hideHelperText={hideHelperText}
      description={description}
      labelId={labelId}
      inputId={ids.input}
      helperTextId={ids.helperText}
      labelBg={labelBg}
    >
      <SelectInput
        id={ids.input}
        dropdownId={dropdownId}
        labelId={labelId}
        status={status}
        placeholder={placeholder}
        onChange={onChange}
        options={options}
        selected={selected}
        searchPlaceholder={searchPlaceholder}
        searchable={searchable}
        wrapSelectedOptionText={wrapSelectedOptionText}
        positionStatic={positionStatic}
        maxMenuHeight={maxMenuHeight}
        multiSelect={multiSelect}
      />
    </FormControl>
  );
};
